export const printContract = (contractText) => {
  if (!contractText) return;
  
  const printWindow = window.open('', '_blank');
  printWindow.document.write(`
    <html>
      <head>
        <title>Contract</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            padding: 20px;
            white-space: pre-wrap;
          }
          @media print {
            body {
              padding: 0;
            }
          }
        </style>
      </head>
      <body>
        <pre>${contractText}</pre>
      </body>
    </html>
  `);
  printWindow.document.close();
  printWindow.print();
};

export const copyToClipboard = async (text) => {
  if (!text) {
    console.error('No text provided to copy');
    return false;
  }

  try {
    // For modern browsers
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    
    // Fallback for older browsers
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');
      textArea.remove();
      return true;
    } catch (err) {
      console.error('Fallback: Error copying text:', err);
      textArea.remove();
      return false;
    }
  } catch (err) {
    console.error('Failed to copy text:', err);
    return false;
  }
}; 